// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3p8ij","ranges":"BmiRanges_ranges__3p49a"};